import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { DropdownComponent } from '../../../dropdown/dropdown.component';
import { DropdownOption } from '../../product.types';
import { OptionType } from '../../../../pages/product/product-list/product-list.mapper';
import { Variant } from '../../../../pages/product/product-page/product.types';
import { JsonApiDocument } from '../../../../services/spree-client/core';

@Component({
  selector: 'app-product-options',
  imports: [DropdownComponent],
  templateUrl: './product-options.component.html',
  styleUrls: ['./product-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductOptionsComponent implements OnInit {
  optionDropdownValue: DropdownOption<JsonApiDocument>['value'][] = [];

  @Input()
  isProductDropdown = false;

  @Input({ required: true })
  options!: OptionType[];

  @Input({ required: true })
  activeVariant!: Variant;

  @Output()
  activeVariantOptionsChange = new EventEmitter<
    {
      typeId: number | string;
      valueId: number | string;
    }[]
  >();

  activeOptions: {
    typeId: number | string;
    valueId: number | string;
  }[] = [];

  dropdowns: {
    presentation: string;
    values: DropdownOption<JsonApiDocument>[];
    optionTypeId: number;
  }[] = [];

  getChildren(option: OptionType): DropdownOption<JsonApiDocument>[] {
    return option.values.map((v) => ({
      name: v.presentation,
      value: v.variant,
      valueId: v.id,
    }));
  }

  ngOnInit(): void {
    this.activeVariant.optionValues.forEach((type) => {
      this.activeOptions.push({ typeId: type.optionTypeId, valueId: type.id });
    });

    this.dropdowns = this.options
      .filter((o) => o.values.length)
      .map((o) => {
        return {
          presentation: o.presentation,
          values: this.getChildren(o),
          optionTypeId: o.id,
        };
      });

    this.dropdowns.forEach((dropdown, index) => {
      const activeVariantOption = this.activeVariant.optionTypes.find(
        (type) => dropdown.optionTypeId === type.id,
      );

      if (!activeVariantOption) {
        return;
      }

      let value: (typeof dropdown.values)[number] | undefined;

      if (activeVariantOption.values[0]) {
        value = dropdown.values.find(
          (v) => v.valueId === activeVariantOption.values[0].id,
        );
      }

      if (value) {
        this.optionDropdownValue[index] = value.value;
      }
    });
  }

  onOptionChange(
    index: number,
    value: JsonApiDocument | null,
    dropdownValues: {
      presentation: string;
      values: DropdownOption<JsonApiDocument>[];
      optionTypeId: number;
    },
  ): void {
    if (!value) {
      return;
    }

    const found = dropdownValues.values.find((v) => v.value.id === value.id);

    this.activeOptions.forEach((o) => {
      if (o.typeId === dropdownValues.optionTypeId && found) {
        o.typeId = dropdownValues.optionTypeId;
        o.valueId = found.valueId;
      }
    });

    this.optionDropdownValue[index] = value;
    this.activeVariantOptionsChange.emit(this.activeOptions);
  }
}
